import {EElementType} from "../models/utils/EElementType";
import {AElement} from "../models/elements/AElement";
import {EnergyBox} from "../models/elements/EnergyBox";
import {Gateway} from "../models/elements/Gateway";
import {Mast} from "../models/elements/Mast";
import {SolarPanel} from "../models/elements/SolarPanel";
import {Unknown} from "../models/elements/Unknown";

class ElementService {

    createsElementAccordingToType(elementType: EElementType): AElement {
        let element: AElement;
        switch (elementType) {
            case EElementType.EnergyBox:
                element = new EnergyBox('', '');
                break;
            case EElementType.Gateway:
                element = new Gateway('');
                break;
            case EElementType.Mast:
                element = new Mast('');
                break;
            case EElementType.SolarPanel:
                element = new SolarPanel('');
                break;
            case EElementType.Unknown:
                element = new Unknown('');
                break;
            default:
                element = new Gateway('');
                break;

        }
        return element;
    }

}

export default new ElementService();
